import React, { useState } from 'react';

const Navbar = ({ activeSection, setActiveSection, data }) => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const navItems = [
        { id: 'home', label: 'HOME' },
        { id: 'about', label: 'ABOUT' },
        { id: 'services', label: 'SERVICES' },
        { id: 'resources', label: 'RESOURCES' },
        { id: 'blog', label: 'BLOG' },
        { id: 'contact', label: 'CONTACT' }
    ];

    const handleNavClick = (sectionId) => {
        setActiveSection(sectionId);
        setIsMobileMenuOpen(false);
    };

    // Default colors if data not available
    const colors = data || {
        name: "BEN COBOS",
        title: "Marriage & Family Therapist",
        nameColor: "#92400e",
        titleColor: "#57534e",
        navTextColor: "#4b5563",
        activeNavColor: "#92400e",
        hoverColor: "#92400e"
    };

    return (
        <>
            {/* Header with name and title */}
            <div className="bg-stone-100/70 py-8 text-center border-b border-stone-200">
                <h1
                    className="text-4xl md:text-5xl font-light tracking-wide mb-2"
                    style={{ color: colors.nameColor }}
                >
                    {colors.name}
                </h1>
                <p
                    className="text-sm md:text-base tracking-widest uppercase"
                    style={{ color: colors.titleColor }}
                >
                    {colors.title}
                </p>
            </div>

            {/* Navigation bar */}
            <nav className="bg-stone-50/80 backdrop-blur-sm sticky top-0 z-50 border-b border-stone-200">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="flex justify-center items-center h-16">
                        {/* Desktop Navigation */}
                        <div className="hidden md:block">
                            <div className="flex items-center space-x-8 lg:space-x-12">
                                {navItems.map((item) => (
                                    <button
                                        key={item.id}
                                        onClick={() => handleNavClick(item.id)}
                                        className="px-2 py-2 text-xs font-medium tracking-wide transition-colors duration-200"
                                        style={{
                                            color: activeSection === item.id ? colors.activeNavColor : colors.navTextColor,
                                            borderBottom: activeSection === item.id ? `2px solid ${colors.activeNavColor}` : 'none'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (activeSection !== item.id) {
                                                e.target.style.color = colors.hoverColor;
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (activeSection !== item.id) {
                                                e.target.style.color = colors.navTextColor;
                                            }
                                        }}
                                    >
                                        {item.label}
                                    </button>
                                ))}
                            </div>
                        </div>

                        {/* Mobile menu button */}
                        <div className="md:hidden absolute right-4">
                            <button
                                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                                className="inline-flex items-center justify-center p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-amber-500"
                                style={{ color: colors.navTextColor }}
                            >
                                <svg
                                    className={`${isMobileMenuOpen ? 'hidden' : 'block'} h-6 w-6`}
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                                </svg>
                                <svg
                                    className={`${isMobileMenuOpen ? 'block' : 'hidden'} h-6 w-6`}
                                    stroke="currentColor"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>

                {/* Mobile Navigation Menu */}
                {isMobileMenuOpen && (
                    <div className="md:hidden bg-white border-t border-gray-200">
                        <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                            {navItems.map((item) => (
                                <button
                                    key={item.id}
                                    onClick={() => handleNavClick(item.id)}
                                    className="block w-full text-center px-3 py-3 text-xs font-medium tracking-wide transition-colors duration-200"
                                    style={{
                                        color: activeSection === item.id ? colors.activeNavColor : colors.navTextColor,
                                        backgroundColor: activeSection === item.id ? '#fef3c7' : 'transparent'
                                    }}
                                    onMouseEnter={(e) => {
                                        if (activeSection !== item.id) {
                                            e.target.style.backgroundColor = '#f9fafb';
                                            e.target.style.color = colors.hoverColor;
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (activeSection !== item.id) {
                                            e.target.style.backgroundColor = 'transparent';
                                            e.target.style.color = colors.navTextColor;
                                        }
                                    }}
                                >
                                    {item.label}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </nav>
        </>
    );
};

export default Navbar;